import styled from 'styled-components/macro'

export function WarningContent({ isBrand }: { isBrand: boolean }) {
  return isBrand ? (
    <Container>
      Changes to this address will only appear in this order.
    </Container>
  ) : (
    <Container>
      Changes to this address will only appear in this order. Please reach out
      to the brand directly if you want to ensure they have the right address
      for you saved to their account.
    </Container>
  )
}

const Container = styled.div`
  min-height: 258px;
`
